
import * as React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { DataGrid } from '@mui/x-data-grid'; // Import DataGrid
import Paper from '@mui/material/Paper';
import { useState } from 'react';

export default function DataGridTable({summarytabledata, appliedUniversities, appliedTerms, appliedTimelines,appliedPrograms,appliedmilestonetype,appliedmilestone }) {
  const navigate = useNavigate(); // Initialize useNavigate


 const handleRowClick = (params) => {
  // navigate(`/individalunitreport` , { state: { UnitName: params.row.UnitName , unit_id: params.row.unit_id, appliedUniversities: appliedUniversities, appliedTerms: appliedTerms, appliedTimelines: appliedTimelines,appliedPrograms:appliedPrograms,appliedmilestonetype:appliedmilestonetype,appliedmilestone:appliedmilestone } }); // Adjust the route as needed
  navigate(`/individalunitreport` , { state: { UnitName: params.row.UnitName , unit_id: params.row.unit_id, appliedUniversities: appliedUniversities, appliedTerms: appliedTerms, appliedTimelines: appliedTimelines,appliedPrograms:appliedPrograms } }); // Adjust the route as needed

  
   };

    const columns = [
      { field: 'sno', headerName: 'S.no', width: 100, headerAlign: 'left', align: 'left',
        sortable: false, // Prevent sorting on S.No
        renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1
       },
      { field: 'UnitName', headerName: 'Unit', width: 300, headerAlign: 'left', align: 'left' },
      { field: 'university', headerName: 'University', width: 200, headerAlign: 'left', align: 'left' },
      { field: 'Teachersdeployed', headerName: 'Total Teachers Deployed', width: 220, headerAlign: 'center', align: 'center' },
      { field: 'ActiveStudents', headerName: 'Active Students', width: 220, headerAlign: 'center', align: 'center' },
  ];
  
  
  // Check if tableData is valid before mapping
  const rows = (summarytabledata || []).map((item, index) => ({
    id: item.unit_id,
    sno: index + 1,
    UnitName: item.name,
    unit_id: item.unit_id,
    university: item.university_name,
    Teachersdeployed: item.teachers_deployed,
    ActiveStudents: item.active_students,
    
  }));

 // Prepare data for CSV download
 const csvData = [
  ["S.no", "Unit Name", "Weak Students (% of Total)", "Phone/Video Engagement (% Milestone Week)", "Student Engagement (% Milestone Week)", "Avg Conversation Time Per Student (Mins)", "LF Responsiveness total (milestone week)", "Red Flag Calls (% of Total, Milestone Week)", "Avg. Grading Quality Score (Assessment Number)", "Teachers with Compliance Flags (% of Total in Unit)", "Average Call Time (Mins)"],
  ...rows.map(row => [row.sno, row.UnitName, row.weekstudent, row.engaged, row.studentengaged, row.AvgConvTimePerStudent, row.responsiveness, row.redflags, row.AvgGradingQualityScore, row.TeachersWithComplianceFlags, row.AverageCallTime])
];

const [paginationModel, setPaginationModel] = useState({
  page: 0, // Starts at the first page
  pageSize: 20, // Shows 20 rows by default
});

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', boxShadow:'none' }}>
      <div style={{ width: "100%" }}>
      <div className="d-flex justify-content-end mb-2"> 
     
        </div>
      <DataGrid
        rows={rows}
        columns={columns}
        paginationModel={paginationModel}
        onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
        autoHeight
        rowCount={rows.length} // Ensure correct total row count
        pageSizeOptions={[20, 50, 100]} // Available page sizes
        onRowClick={handleRowClick}
        sx={{
          fontFamily: "Nunito Sans, sans-serif",
          fontSize: "14px",
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#ebebeb",
            color: "#000",
            fontWeight: "bold",
            fontSize: "14px",
            padding: "6px",
            fontFamily: "Nunito Sans, sans-serif",
          },
          "& .MuiDataGrid-cell": {
            padding: "6px",
            fontFamily: "Nunito Sans, sans-serif",
            fontSize: "14px",
          },
          "& .MuiDataGrid-row:hover": {
            cursor: "pointer",
            backgroundColor: "#f5f5f5",
          },
        }}
      />
    </div>
    </Paper>
  );
}



